 
import { removeNamespace } from '@piri/vue-utils';

import mutationTypes from './types/mutationTypes';
import moduleName from './moduleName';

const mutationTypesInModule = removeNamespace(moduleName, mutationTypes);

const updateFiles = (state, file) => {
  if (!state.files[file.name]) {
    state.files = { ...state.files, [file.name]: [] };
  }

  state.files[file.name].splice(0);
  Object.assign(state.files[file.name], file.files, { length: file.files.length });
};

const createUploader = (state, fileUploader) => {
  state.fileUploaders = { ...state.fileUploaders, [fileUploader.key]: fileUploader };
};

const disposeUploader = (state, key) => {
  delete state.fileUploaders[key];
};

const initiateUploader = (state, { key, instance }) => {
  state.fileUploaders[key] = { ...state.fileUploaders[key], instance };
};

export default {
  [mutationTypesInModule.UPDATE_FILES]: updateFiles,
  [mutationTypesInModule.CREATE_UPLOADER]: createUploader,
  [mutationTypesInModule.DISPOSE_UPLOADER]: disposeUploader,
  [mutationTypesInModule.INITIATE_UPLOADER]: initiateUploader,
};
